// MT — script propio de la tienda (vanilla, sin librerías)
document.addEventListener('DOMContentLoaded', function () {
  initResenasAleatorias();
  initReveal();
  initContadores();
  initGaleriaProducto();
  initVariantesProducto();
  initAntesDespues();
  initBarraCompraFija();
  initViendoAhora();
  initCuentaAtrasOferta();
  initEmpujonCantidadCarrito();
});

// Cuando el navegador restaura la página desde su caché de "atrás/adelante"
// (muy habitual al volver con el botón atrás en móvil), NO se vuelve a
// disparar DOMContentLoaded — así que sin esto, el orden de las reseñas se
// quedaba congelado tal cual estaba la primera vez que se cargó la página,
// y parecía que siempre salían "las mismas". Al restaurarse así, se vuelve
// a barajar para que también cambien al volver atrás, no solo al recargar.
window.addEventListener('pageshow', function (event) {
  if (event.persisted) {
    initResenasAleatorias();
    initViendoAhora();
    initCuentaAtrasOferta();
  }
});

var mtCuentaAtrasIntervalo = null;
function initCuentaAtrasOferta() {
  // Cuenta atrás de la barra "MT – Aviso de oferta urgente". Dos modos, por
  // caja (cada una puede tener su propio `data-mt-fecha-limite`):
  //   - CON fecha límite (formato AAAA-MM-DDTHH:MM:SS, hora local): cuenta
  //     hasta ESE momento exacto — para una oferta con fin de verdad que
  //     luego se cumple (se sube el precio ese día de verdad).
  //   - SIN fecha límite: modo antiguo, cuenta hasta las 23:59:59 de HOY y
  //     se recalcula sola cada día (aviso evergreen tipo "termina hoy").
  var cajas = document.querySelectorAll('[data-mt-cuenta-atras]');
  if (!cajas.length) return;

  function pad(n) { return (n < 10 ? '0' : '') + n; }

  function finDeHoy() {
    var ahora = new Date();
    return new Date(ahora.getFullYear(), ahora.getMonth(), ahora.getDate(), 23, 59, 59, 999);
  }

  function poner(caja, n, valorId, etiquetaId, etiqueta) {
    var vEl = caja.querySelector('[data-mt-' + valorId + ']');
    var lEl = caja.querySelector('[data-mt-' + etiquetaId + ']');
    if (vEl) vEl.textContent = pad(n);
    if (lEl) lEl.textContent = etiqueta;
  }

  function actualizar() {
    var ahora = Date.now();
    cajas.forEach(function (caja) {
      var fechaLimite = caja.getAttribute('data-mt-fecha-limite');
      var fin = fechaLimite ? new Date(fechaLimite) : finDeHoy();
      // Si la fecha límite viene mal escrita (texto no válido), Date la
      // convierte en "Invalid Date" — se cae al modo "hoy" para no romper
      // la cuenta atrás por un error de tecleo en el editor.
      if (isNaN(fin.getTime())) fin = finDeHoy();
      var restante = Math.max(0, fin.getTime() - ahora);
      var dias = Math.floor(restante / 86400000);
      // Con un día o más por delante se muestran días/horas/minutos (los
      // segundos no aportan nada a esa distancia y solo generan ruido);
      // por debajo de 24h se cambia a horas/minutos/segundos, con más
      // precisión cuanto más cerca está el final — mismas 3 cajas, unidad
      // distinta según haga falta.
      if (dias > 0) {
        var horasEnDia = Math.floor((restante % 86400000) / 3600000);
        var minutos = Math.floor((restante % 3600000) / 60000);
        poner(caja, dias, 'v1', 'l1', 'd');
        poner(caja, horasEnDia, 'v2', 'l2', 'h');
        poner(caja, minutos, 'v3', 'l3', 'm');
      } else {
        var h = Math.floor(restante / 3600000);
        var m = Math.floor((restante % 3600000) / 60000);
        var s = Math.floor((restante % 60000) / 1000);
        poner(caja, h, 'v1', 'l1', 'h');
        poner(caja, m, 'v2', 'l2', 'm');
        poner(caja, s, 'v3', 'l3', 's');
      }

      // Modo "últimas horas": la escalada es real porque el plazo es real —
      // con menos de `data-mt-horas-criticas` por delante se añade la clase
      // .mt-urgente-critico a la caja del texto que la sección auto-genera
      // (#shopify-section-<id>, ver el CSS con colores intensificados) y se
      // cambia la etiqueta pequeña. Se recalcula solo, sin recargar página.
      var horasCriticas = parseFloat(caja.getAttribute('data-mt-horas-criticas'));
      if (!isNaN(horasCriticas)) {
        var esCritico = restante > 0 && restante <= horasCriticas * 3600000;
        var idSeccion = caja.getAttribute('data-mt-section-id');
        var wrapper = idSeccion ? document.getElementById('shopify-section-' + idSeccion) : null;
        if (wrapper) wrapper.classList.toggle('mt-urgente-critico', esCritico);
        var contenedor = caja.closest('.mt-urgente-inner');
        if (contenedor) {
          var eyNormal = contenedor.querySelector('[data-mt-eyebrow-normal]');
          var eyCritico = contenedor.querySelector('[data-mt-eyebrow-critico]');
          if (eyNormal && eyCritico) {
            eyNormal.hidden = esCritico;
            eyCritico.hidden = !esCritico;
          }
        }
      }
    });
  }

  actualizar();
  // Si la página se restaura desde la caché de "atrás/adelante" ya podía
  // haber un intervalo anterior corriendo — se limpia antes de crear otro
  // para no duplicar el tictac.
  if (mtCuentaAtrasIntervalo) clearInterval(mtCuentaAtrasIntervalo);
  mtCuentaAtrasIntervalo = setInterval(actualizar, 1000);
}

function initEmpujonCantidadCarrito() {
  // Botón "Añade 1 más y ahorra 10 €" en la línea del carrito: dispara el
  // botón "+" nativo de Dawn (misma actualización AJAX de siempre), no
  // reimplementa el cambio de cantidad por su cuenta. Con delegación de
  // eventos en document (una sola vez, con guarda) en vez de enganchar cada
  // botón: Dawn vuelve a renderizar la fila del carrito tras cada cambio de
  // cantidad, así que un listener puesto directamente en el botón se perdía
  // en cuanto se repintaba — la delegación sigue funcionando pase lo que
  // pase con el DOM.
  if (window._mtEmpujonCarritoWired) return;
  window._mtEmpujonCarritoWired = true;
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-mt-cart-nudge-plus]');
    if (!btn) return;
    var contenedor = btn.closest('.quantity-popover-container');
    var masBtn = contenedor && contenedor.querySelector('quantity-input .quantity__button[name="plus"]');
    if (masBtn) masBtn.click();
  });
}

function initViendoAhora() {
  // Cifra de "personas viendo esto ahora" — aleatoria (1 a 10), no un
  // recuento real de visitantes. Se pidió así a propósito para dar
  // sensación de escasez; cambia en cada carga/recarga de la página.
  var el = document.getElementById('mt-prod-viendo-ahora');
  var numEl = document.getElementById('mt-prod-viendo-ahora-num');
  if (!el || !numEl) return;
  var n = Math.floor(Math.random() * 10) + 1;
  numEl.textContent = n;
  el.style.display = '';
}

function initResenasAleatorias() {
  // Baraja el orden de las reseñas del carrusel en cada carga de página, para
  // que no se vean siempre las mismas primero, y CREA aquí mismo (en el
  // navegador) la copia visual que hace que el carrusel dé la vuelta sin
  // salto. A propósito: el HTML que sirve el servidor solo contiene cada
  // reseña UNA vez — nada de contenido duplicado para quien vea el código
  // fuente o para un rastreador; el "duplicado" nace como clon en tiempo de
  // ejecución, marcado aria-hidden, solo para el efecto visual del bucle.
  var pistas = document.querySelectorAll('[data-mt-marquee]');
  if (!pistas.length) return;
  pistas.forEach(function (pista) {
    var track = pista.querySelector('.mt-resenas-track');
    if (!track) return;

    // Si ya había una copia visual de una barajada anterior (p. ej. al
    // volver a ejecutarse tras restaurar la página desde la caché del
    // navegador), se quita antes de generar una nueva — si no, se acumulan
    // copias duplicadas de verdad en el DOM.
    pista.querySelectorAll('.mt-resenas-dup').forEach(function (dup) { dup.remove(); });

    var reales = Array.prototype.filter.call(track.children, function (el) {
      return el.classList.contains('mt-resena-card');
    });
    if (reales.length < 2) return;

    // Fisher-Yates sobre las tarjetas reales, y las reordena de verdad en el DOM.
    var orden = reales.slice();
    for (var i = orden.length - 1; i > 0; i--) {
      var j = Math.floor(Math.random() * (i + 1));
      var tmp = orden[i]; orden[i] = orden[j]; orden[j] = tmp;
    }
    orden.forEach(function (el) { track.appendChild(el); });

    // Copia visual: clona el set ya barajado. Cada tarjeta clonada puede
    // llevar dentro un degradado SVG de media estrella con un id propio —
    // hay que regenerarlo en el clon para no dejar ids duplicados en la
    // página (dos elementos con el mismo id es HTML inválido).
    var dupWrap = document.createElement('div');
    dupWrap.className = 'mt-resenas-dup';
    dupWrap.setAttribute('aria-hidden', 'true');
    dupWrap.setAttribute('tabindex', '-1');
    dupWrap.style.display = 'contents';
    orden.forEach(function (el) {
      var clon = el.cloneNode(true);
      clon.querySelectorAll('[id]').forEach(function (nodo) {
        var idViejo = nodo.id;
        var idNuevo = idViejo + '-dup';
        nodo.id = idNuevo;
        clon.querySelectorAll('[style*="' + idViejo + '"]').forEach(function (usa) {
          usa.setAttribute('style', usa.getAttribute('style').replace(idViejo, idNuevo));
        });
      });
      dupWrap.appendChild(clon);
    });
    track.appendChild(dupWrap);
  });
}

function initBarraCompraFija() {
  var barra = document.getElementById('mt-prod-sticky');
  var addBtnReal = document.getElementById('mt-prod-add');
  var stickyBtn = document.getElementById('mt-prod-sticky-btn');
  if (!barra || !addBtnReal) return;

  // El botón de la barra fija dispara el formulario real (mismo id de
  // variante, mismas validaciones) — no es una compra "aparte".
  if (stickyBtn) {
    stickyBtn.addEventListener('click', function () {
      addBtnReal.click();
    });
  }

  // Comprobación directa por scroll (en vez de IntersectionObserver): más
  // predecible entre navegadores y no depende de que la pestaña esté
  // "pintando" activamente para actualizarse.
  var pendiente = false;
  function comprobar() {
    pendiente = false;
    var rect = addBtnReal.getBoundingClientRect();
    var pasado = rect.bottom < 0;
    barra.classList.toggle('mt-visible', pasado);
  }
  window.addEventListener('scroll', function () {
    if (pendiente) return;
    pendiente = true;
    setTimeout(comprobar, 50);
  }, { passive: true });
  comprobar();
}

function initAntesDespues() {
  var sliders = document.querySelectorAll('[data-mt-antes-despues]');
  if (!sliders.length) return;
  sliders.forEach(function (slider) {
    var range = slider.querySelector('.mt-ad-range');
    function setPos(pct) {
      pct = Math.max(0, Math.min(100, pct));
      slider.style.setProperty('--pos', pct + '%');
      if (range) range.value = pct;
    }
    function pctDesdeEvento(clientX) {
      var rect = slider.getBoundingClientRect();
      return ((clientX - rect.left) / rect.width) * 100;
    }
    var arrastrando = false;
    slider.addEventListener('pointerdown', function (e) {
      arrastrando = true;
      slider.setPointerCapture(e.pointerId);
      setPos(pctDesdeEvento(e.clientX));
    });
    slider.addEventListener('pointermove', function (e) {
      if (!arrastrando) return;
      setPos(pctDesdeEvento(e.clientX));
    });
    slider.addEventListener('pointerup', function () { arrastrando = false; });
    slider.addEventListener('pointercancel', function () { arrastrando = false; });
    if (range) {
      range.addEventListener('input', function () { setPos(parseFloat(range.value)); });
    }
  });
}

function initGaleriaProducto() {
  var minis = document.querySelectorAll('.mt-prod-mini');
  var principal = document.getElementById('mt-prod-imagen-principal');
  if (!minis.length || !principal) return;
  minis.forEach(function (btn) {
    btn.addEventListener('click', function () {
      var full = btn.getAttribute('data-full');
      if (!full) return;
      principal.style.opacity = '0';
      setTimeout(function () {
        principal.src = full;
        principal.style.opacity = '1';
      }, 120);
      minis.forEach(function (m) { m.classList.remove('mt-activa'); });
      btn.classList.add('mt-activa');
    });
  });
}

function initVariantesProducto() {
  var form = document.getElementById('mt-form-producto');
  var data = document.getElementById('mt-prod-variantes');
  if (!form || !data) return;
  var variantes;
  try { variantes = JSON.parse(data.textContent); } catch (e) { return; }
  if (!variantes.length) return;

  var grupos = document.querySelectorAll('.mt-prod-opcion-valores');
  var idInput = document.getElementById('mt-prod-variant-id');
  var precioEl = document.getElementById('mt-prod-precio');
  var precioTachadoEl = document.getElementById('mt-prod-precio-tachado');
  var descuentoEl = document.getElementById('mt-prod-descuento-badge');
  var addBtn = document.getElementById('mt-prod-add');
  var addTexto = document.getElementById('mt-prod-add-texto');
  var principal = document.getElementById('mt-prod-imagen-principal');
  var textoAgotado = addBtn ? addBtn.getAttribute('data-texto-agotado') : null;
  var urgenciaEl = document.getElementById('mt-prod-urgencia');
  var stickyPrecioEl = document.getElementById('mt-prod-sticky-precio');
  var stickyBtn = document.getElementById('mt-prod-sticky-btn');
  var stickyTexto = document.getElementById('mt-prod-sticky-btn-texto');
  var stickyTextoAgotado = stickyBtn ? stickyBtn.getAttribute('data-texto-agotado') : null;
  var stickyTextoElige = stickyBtn ? stickyBtn.getAttribute('data-elige-opcion') : null;

  function seleccionActual() {
    var sel = [];
    grupos.forEach(function (g) {
      var activo = g.querySelector('.mt-prod-pill.mt-activa');
      sel.push(activo ? activo.getAttribute('data-value') : null);
    });
    return sel;
  }

  function encontrarVariante() {
    var sel = seleccionActual();
    return variantes.find(function (v) {
      return v.options.every(function (opt, i) { return sel[i] === null || opt === sel[i]; });
    });
  }

  function actualizar() {
    var v = encontrarVariante();
    if (!v) return;
    idInput.value = v.id;
    if (precioEl) precioEl.textContent = v.price;
    if (precioTachadoEl) {
      if (v.compare_at_price && v.compare_at_price !== v.price) {
        precioTachadoEl.textContent = v.compare_at_price;
        precioTachadoEl.style.display = '';
        if (descuentoEl) {
          if (v.compare_at_price_raw > v.price_raw) {
            var pct = Math.round(((v.compare_at_price_raw - v.price_raw) / v.compare_at_price_raw) * 100);
            descuentoEl.textContent = '-' + pct + '%';
            descuentoEl.style.display = '';
          } else {
            descuentoEl.style.display = 'none';
          }
        }
      } else {
        precioTachadoEl.style.display = 'none';
        if (descuentoEl) descuentoEl.style.display = 'none';
      }
    }
    // Mientras falte elegir alguna opción (p. ej. la talla), el botón de
    // compra queda deshabilitado y avisa de qué falta — no se deja comprar
    // "a ciegas" con la talla más pequeña puesta por defecto.
    var completa = seleccionActual().indexOf(null) === -1;
    var textoElige = addBtn ? addBtn.getAttribute('data-elige-opcion') : null;
    if (addBtn) {
      if (!completa) {
        addBtn.disabled = true;
        if (addTexto && textoElige) addTexto.textContent = textoElige;
      } else {
        addBtn.disabled = !v.available;
        if (addTexto) addTexto.textContent = v.available ? addTexto.getAttribute('data-disponible') || addTexto.textContent : (textoAgotado || addTexto.textContent);
      }
    }
    if (principal && v.featured_image) principal.src = v.featured_image;
    if (stickyPrecioEl) stickyPrecioEl.textContent = v.price;
    if (stickyBtn) {
      stickyBtn.disabled = !completa || !v.available;
      if (stickyTexto) {
        if (!completa && stickyTextoElige) {
          stickyTexto.textContent = stickyTextoElige;
        } else if (addTexto) {
          // Mismo texto que ya calculó el botón principal (disponible/agotado).
          stickyTexto.textContent = v.available ? (addTexto.getAttribute('data-disponible') || addTexto.textContent) : (stickyTextoAgotado || addTexto.textContent);
        }
      }
    }
    if (urgenciaEl) {
      // Aviso de "quedan X unidades" conectado al stock REAL de la variante
      // elegida: nunca se inventa un número, se lee de los datos reales.
      var umbral = parseInt(urgenciaEl.getAttribute('data-umbral'), 10) || 0;
      var activa = urgenciaEl.getAttribute('data-activa') === 'true';
      var sufijo = urgenciaEl.getAttribute('data-suffix') || '';
      if (activa && v.inventory_management && v.inventory_quantity > 0 && v.inventory_quantity <= umbral) {
        urgenciaEl.textContent = 'Quedan ' + v.inventory_quantity + ' ' + sufijo;
        urgenciaEl.style.display = '';
        urgenciaEl.classList.toggle('mt-prod-urgencia-critico', v.inventory_quantity < 5);
      } else {
        urgenciaEl.textContent = '';
        urgenciaEl.style.display = 'none';
        urgenciaEl.classList.remove('mt-prod-urgencia-critico');
      }
    }
  }

  grupos.forEach(function (g) {
    g.querySelectorAll('.mt-prod-pill').forEach(function (btn) {
      btn.addEventListener('click', function () {
        g.querySelectorAll('.mt-prod-pill').forEach(function (b) { b.classList.remove('mt-activa'); });
        btn.classList.add('mt-activa');
        actualizar();
      });
    });
  });

  var cantidadInput = document.getElementById('mt-prod-cantidad');
  form.querySelectorAll('.mt-prod-cant-btn').forEach(function (btn) {
    btn.addEventListener('click', function () {
      if (!cantidadInput) return;
      var val = parseInt(cantidadInput.value, 10) || 1;
      if (btn.getAttribute('data-accion') === 'sumar') val += 1;
      else val = Math.max(1, val - 1);
      cantidadInput.value = val;
    });
  });

  // Botón "Sí, quiero 2 y ahorrar 10€": pone la cantidad en 2 y dispara el
  // botón real de compra (mismas validaciones, mismo formulario) en un solo
  // clic. Si todavía no se ha elegido talla, no compra a ciegas: lleva al
  // bloque de opciones para que se elija primero.
  var btnDescuentoCantidad = document.getElementById('mt-prod-descuento-cantidad-btn');
  var avisoTalla = document.getElementById('mt-prod-aviso-talla');
  if (btnDescuentoCantidad && addBtn) {
    btnDescuentoCantidad.addEventListener('click', function () {
      if (addBtn.disabled) {
        // No compra a ciegas sin talla — pero hay que dejarlo claro con algo
        // más que un scroll silencioso (que no se nota si ya está a la
        // vista): se muestra un aviso junto al botón y se sacude el grupo de
        // opciones que falte por elegir.
        if (avisoTalla) {
          avisoTalla.style.display = '';
          clearTimeout(avisoTalla._mtTimeout);
          avisoTalla._mtTimeout = setTimeout(function () { avisoTalla.style.display = 'none'; }, 3000);
        }
        var sel = seleccionActual();
        grupos.forEach(function (g, i) {
          if (sel[i] !== null) return;
          g.classList.remove('mt-aviso');
          void g.offsetWidth; // reinicia la animación si ya se había disparado antes
          g.classList.add('mt-aviso');
          setTimeout(function () { g.classList.remove('mt-aviso'); }, 600);
        });
        var opciones = form.querySelector('.mt-prod-opciones');
        if (opciones) opciones.scrollIntoView({ behavior: 'smooth', block: 'center' });
        return;
      }
      if (avisoTalla) avisoTalla.style.display = 'none';
      if (cantidadInput) cantidadInput.value = 2;
      addBtn.click();
    });
  }
}

function initReveal() {
  var els = document.querySelectorAll('.mt-reveal');
  if (!els.length) return;
  function mostrarTodo() { els.forEach(function (el) { el.classList.add('mt-visible'); }); }
  if (!('IntersectionObserver' in window)) { mostrarTodo(); return; }
  var obs = new IntersectionObserver(function (entries) {
    entries.forEach(function (entry) {
      if (entry.isIntersecting) {
        entry.target.classList.add('mt-visible');
        obs.unobserve(entry.target);
      }
    });
  }, { threshold: 0.15, rootMargin: '0px 0px -40px 0px' });
  els.forEach(function (el) { obs.observe(el); });
  // Red de seguridad: si por lo que sea algo se queda sin revelar (fallo del
  // observer, elemento fuera de flujo...), lo forzamos igualmente.
  setTimeout(mostrarTodo, 2500);
}

function initContadores() {
  var els = document.querySelectorAll('.mt-contador[data-target]');
  if (!els.length) return;
  var reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var obs = new IntersectionObserver(function (entries) {
    entries.forEach(function (entry) {
      if (!entry.isIntersecting) return;
      var el = entry.target;
      var target = parseFloat(el.getAttribute('data-target')) || 0;
      var suffix = el.getAttribute('data-suffix') || '';
      obs.unobserve(el);
      if (reduced) { el.textContent = target + suffix; return; }
      var start = null;
      var dur = 1400;
      function tick(ts) {
        if (!start) start = ts;
        var p = Math.min((ts - start) / dur, 1);
        var eased = 1 - Math.pow(1 - p, 3);
        var val = target % 1 === 0 ? Math.floor(target * eased) : (target * eased).toFixed(1);
        el.textContent = val + suffix;
        if (p < 1) requestAnimationFrame(tick);
      }
      requestAnimationFrame(tick);
    });
  }, { threshold: 0.4 });
  els.forEach(function (el) { obs.observe(el); });
}
